import { Breadcrumbs } from '@components/display/breadcrumbs';
import { usePublicLayoutOptions } from '@components/layout/public';
import { Button } from '@components/utility/buttons';
import { useAppSelector } from '@hooks/generic';
import { NotFound } from '@routes/NotFound';
import { selectBreadcrumbs } from '@store/breadcrumbSlice';
import { VideosOverview } from '@videos/routes/VideosOverview';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Route, Routes } from 'react-router-dom';

export const VideosRoutes = () => {
    const breadcrumbs = useAppSelector(selectBreadcrumbs);
    const extraToolbar = useMemo(
        () => (
            <Breadcrumbs
                path={breadcrumbs}
                extraButton={
                    <Button
                        fullRounded
                        href="https://www.youtube.com/@VictronEnergyBV/?sub_confirmation=1"
                        target="_blank"
                        size="small"
                    >
                        <FormattedMessage
                            id="videos.subscribeToYoutube"
                            defaultMessage="Subscribe to our Youtube channel"
                        />
                    </Button>
                }
            />
        ),
        [breadcrumbs]
    );
    usePublicLayoutOptions({ extraToolbar });

    return (
        <Routes>
            <Route index element={<VideosOverview />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};
